<form class="sdp-saml-wizard-form" [formGroup]="form" novalidate>
	<div class="sdp-clear"></div>
	<div *ngIf="!isAlreadyUploaded">
		<h5>{{ "sdp.label.step" | translate }} 1</h5>
		<div class="sdp-form-control">
			{{ "saml.wizard.upload.step1" | translate }}
		</div>
		<div class="sdp-user-card-seperator"></div>
		<h5>{{ "sdp.label.step" | translate }} 2</h5>
		<div>{{ "saml.wizard.upload.step2" | translate }}</div>
		<div class="sdp-image-manager-container">
			<input class="sdp-image-manager-input sdp-saml-wizard-upload-file-input" #fileInput type="file" (change)="fileOnChange($event)"
			/>
			<button type="button" color="accent" mat-raised-button class="sdp-saml-wizard-upload-file-button">{{ "imageManager.selector.button" | translate }}</button>
			<div class="sdp-image-upload-uploaded-successful" *ngIf="fileName">
				<span>{{ fileName }}</span> {{ "imageManager.file.uploaded" | translate }}
			</div>
		</div>
		<div *ngIf="isShowExisting">
			<button class="sdp-mat-button-thin" type="button" mat-raised-button color="accent" (click)="showAlreadyUploaded()">{{ "saml.wizard.upload.use.existing" | translate }}</button>
		</div>
	</div>
	<div *ngIf="isAlreadyUploaded">{{ "saml.wizard.upload.metadata.update" | translate }}
		<button class="sdp-mat-button-thin" type="button" mat-raised-button color="accent" (click)="showFileUpload()">{{ "saml.wizard.upload.another" | translate }}</button>
	</div>
</form>